import {
  OrderSelectionOptionItem,
  OrderStatusCode,
  ROLE,
} from '../../interface/interface';

export const handleAmendingDispensedStatus = (
  groups: unknown,
  allOrderStatus: OrderSelectionOptionItem[],
  commonAdminStatuses: OrderStatusCode[],
) => {
  if ((groups as string[])[0] !== ROLE.Admin) {
    return allOrderStatus.filter((e) =>
      [OrderStatusCode.READY_FOR_SCAN].includes(e?.id),
    );
  } else {
    return allOrderStatus.filter((e) => commonAdminStatuses.includes(e?.id));
  }
};
